import { useState } from "react";
import { useRecoilCallback, useRecoilState } from "recoil";
import { FamilyService } from "src/FamilyGroup/services/family";
import ManageStorage from "src/shared/global/manageStorage";
import { parseJwt } from "src/shared/global/helpers";
import { familyGroupState, tutoresGroupState } from "../atom";

export default function useFamilyGroupLoader() {
    const [loading, setLoading] = useState(false);
    const [familyGroup, setFamilyGroup] = useRecoilState(familyGroupState);
    const [tutoresGroup, setTutoresGroup] = useRecoilState(tutoresGroupState);

    const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
    const payloadToken = tokenUser ? parseJwt(tokenUser) : null;

    const loadFamilyGroup = useRecoilCallback(({ snapshot }) => async () => {
        console.log("Loading family group...");
        const release = snapshot.retain();
        setLoading(true);
        try {
            const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
            const payloadToken = tokenUser ? parseJwt(tokenUser) : null;
            if (payloadToken?.Username) {
                console.log("Fetching family group for:", payloadToken.Username);

                const response = await FamilyService.getFamilyGroup(payloadToken.Username);
                setFamilyGroup(response.data);

                const tutores = await FamilyService.getTutor(payloadToken.Username);
                setTutoresGroup(tutores.data);
            }
        } catch (error) {
            // catchErrorApi(error);
        } finally {
            setLoading(false);
            release();
        }
    }, []);

    const removeFamilyMember = useRecoilCallback(({ snapshot }) => async ({ tutRut, rutPaciente, pacCorrel, actorRol }) => {
        const release = snapshot.retain();
        setLoading(true);
        try {
            const body = {
                tutRut,
                rutPaciente,
                actorRol,
                pacCorrel
            };
            await FamilyService.removeFamilyMember(body);
            // Recargar grupo familiar después de eliminar
            await loadFamilyGroup();
        } catch (error) {
            // catchErrorApi(error);
        } finally {
            setLoading(false);
            release();
        }
    }, [loadFamilyGroup]);

    return {
        loading,
        familyGroup,
        tutoresGroup,
        payloadToken,
        loadFamilyGroup,
        removeFamilyMember,
    };
}
